import React from 'react';

import Icon from '-!svg-react-loader?name=Untapped!../../../images/icons/untapped.svg';

const Untapped = () => {
	return <Icon />;
};

export default Untapped;
